import moment from 'moment/moment';

class UserRatesTimer {
    constructor($element) {
        this.interval = null;
        this.$element = $element;
        this.end = $element.data('voting-open-until');

        this.callback = () => {};
    }
    onFinish(callback) {
        this.callback = callback;
    }
    process() {
        const now = moment();
        const time = moment(this.end);

        if (now > time) {
            this.close();
            return;
        }
        this.render();
    }
    start() {
        this.$element.find('.rtl-closed').addClass('hidden');
        this.$element.find('.rtl-running').removeClass('hidden');

        this.interval = setInterval(() => {
            this.process();
        }, 1000);
    }
    reset() {
        clearInterval(this.interval);
    }
    close() {
        this.reset();

        this.$element.find('.rtl-running').addClass('hidden');
        this.$element.find('.rtl-closed').removeClass('hidden');

        this.callback();
    }
    render() {
        moment.locale('pl');
        const time = moment(this.end);

        this.$element.find('strong').text(time.fromNow());
    }
}

export default UserRatesTimer;



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/user-rates/timer.js